module.exports = __webpack_public_path__ + "img/au.216d487e.png";